import React from 'react'

import { Avatar } from '@material-ui/core'

const Image = ({ src, imgAlt, variant, className, clicked, style, imgProps }) => {
  return (
    <Avatar
      src={src}
      alt={imgAlt}
      variant={variant}
      onClick={clicked}
      className={className}
      imgProps={{ style: { objectFit: 'contain' }, ...imgProps }}
      style={style}
    />
  )
}

export default Image
